import { useEffect, useState } from "react";

const loadScript = () => new Promise((resolve) => {
    if( document.getElementById("razorpay") ) return 
    
    const script = document.createElement('script');
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.id = "razorpay"

    script.onload = () => {
        console.log('razorpay loaded successfully');
        resolve(true);
    };

    script.onerror = () => {
        console.log('error in loading razorpay');
        resolve(false);
    };

    document.body.appendChild(script);
});


export default ({
    orderId,
    amount,
    bookingId,
    customer = {},
    cb = () => {}
}) => {

    const [options,] = useState({
        "key": "rzp_live_9ahH7HBC42cQqs",
        "amount": +amount * 100,
        "currency": "INR",
        "name": "Acme Corp", //your business name
        "description": "Test Transaction",
        "image": "https://example.com/your_logo",
        "order_id": orderId,
        "handler": function (response) {
            cb("success", response)
            console.log("razorpay", response)
        },
        "prefill": {
            "name": customer.name || customer.firstName,
            "email": customer.email,
            "contact": customer.mobile
        },
        "notes": {
            "address": "Razorpay Corporate Office"
        },
        "theme": {
            "color": "#3399cc"
        }
    })


    useEffect(() => {
        const res = loadScript()

        if (!res) {
            console.log('Razorpay SDK failed to load. Are you online?');
            return;
        }

        if( orderId ){
            const rzp1 = new window.Razorpay(options);
    
            rzp1.on('payment.submit', (response) => {
                // console.log('payment success', response)
            })
    
            rzp1.on('payment.failed', (response) => {
                console.log("payment failed", response)
                cb("failed", response)
            })
    
            rzp1.open()
        }

    }, [ orderId ])


    return null;
}